import { fetchWithToken } from '@infra/http/fetchWithToken';

export type ResolveTrackAlbumResult =
  | { status: 'ok'; albumId: string }
  | { status: 'not_found' }
  | { status: 'error' };

const TRACK_URI_REGEX = /^spotify:track:[A-Za-z0-9]{22}$/;

/**
 * Resolves the parent album for a Spotify track URI via /catalog/api/track-album.
 * Also validates client-side so we skip the round-trip for malformed URIs.
 */
export async function resolveTrackAlbum(
  trackUri: string,
): Promise<ResolveTrackAlbumResult> {
  if (!TRACK_URI_REGEX.test(trackUri)) {
    return { status: 'error' };
  }

  try {
    const response = await fetchWithToken(
      `/catalog/api/track-album?trackUri=${encodeURIComponent(trackUri)}`,
      { method: 'GET' },
    );

    if (response.status === 404) {
      return { status: 'not_found' };
    }

    if (!response.ok) {
      return { status: 'error' };
    }

    const body = (await response.json().catch(() => null)) as {
      albumId?: string;
    } | null;

    if (!body?.albumId) {
      return { status: 'error' };
    }

    return { status: 'ok', albumId: body.albumId };
  } catch {
    return { status: 'error' };
  }
}
